import { useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ScreenSizeQueries } from '@/constants/breakpoints';

export interface ModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Modal = ({ open, setOpen, children }: React.PropsWithChildren<ModalProps>) => {
  const isXSmall = useMediaQuery(ScreenSizeQueries.xsOnly);

  // Prevent body scroll on mobile when modal is open
  useEffect(() => {
    if (!open || !isXSmall) {
      // Reset body styles if modal is closed or screen is resized away.
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      return;
    }

    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalWidth = document.body.style.width;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';

    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = originalWidth;
    };
  }, [isXSmall, open]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      {isXSmall && <Dialog.Overlay className="fixed inset-0 bg-transparent" />}
      {children}
    </Dialog.Root>
  );
};

Modal.Trigger = Dialog.Trigger;

export default Modal;
